var __rspack_ns_object = JSON.parse('{"Measurements":"Metingen","Studies":"Studieën"}')